/** @jsxImportSource react */
import React, { useState } from 'react';
import { ExternalLink } from 'lucide-react';
import { useTranslation } from '../i18n';
import { Button } from './ui/Button';

interface LinkPreviewProps {
  url: string;
}

export const LinkPreview: React.FC<LinkPreviewProps> = ({ url }) => {
  const { t } = useTranslation();
  const [previewFailed, setPreviewFailed] = useState(false);

  const isDirectImage = /\.(jpg|jpeg|png|gif|webp|bmp|svg)(\?.*)?$/i.test(url);

  const screenshotUrl = `https://s.wordpress.com/mshots/v1/${encodeURIComponent(url)}?w=400`;

  const handleError = () => {
    // If the screenshot fails, we set previewFailed to true.
    // If it was a direct image link that failed, this will also trigger the fallback.
    setPreviewFailed(true);
  };

  if (previewFailed) {
    return (
        <a href={url} target="_blank" rel="noopener noreferrer">
            <Button variant="outline">
                {t('viewProduct') || 'View Product'}
                <ExternalLink className="h-4 w-4 ms-2" />
            </Button>
        </a>
    );
  }

  const imageUrl = isDirectImage ? url : screenshotUrl;

  return (
    <a href={url} target="_blank" rel="noopener noreferrer" className="block border rounded-lg overflow-hidden hover:shadow-md transition-shadow max-w-sm group">
      <img
        src={imageUrl}
        alt={t('productPreview')}
        className="w-full h-auto object-cover max-h-64 bg-gray-100 group-hover:opacity-90 transition-opacity"
        onError={handleError}
        loading="lazy"
      />
    </a>
  );
};
